<abi-back-button *ngIf="readonly"></abi-back-button>
<abi-spinner *ngIf="!job && facebookId || loading">
</abi-spinner>
<div [formGroup]="form" [hidden]="loading">
  <div class="card-deck">
    <div class="card mb-1">
      <div class="card-header py-0 pr-0 overflow-hidden">
        <h4 class="card-title mb-0 my-2 float-left">Contact</h4>
        <img *ngIf="profile" class="float-right" [style.width]="profile.width" [style.height]="profile.height"
          [src]="profile.src" alt="Facebook profile" />
      </div>
      <div *ngIf="!job" class="card-body pb-1">

        <p>Please login to Facebook to continue</p>
        <div class="media-body">
          <h5>{{ profile?.name }}</h5>
          {{ profile?.email }}
        </div>

        <div class="fb-login-button" data-max-rows="1" data-size="large" data-button-type="continue_with"
          data-show-faces="false" data-auto-logout-link="false" data-use-continue-as="true"
          data-scope="public_profile,email">
        </div>

      </div>
      <div *ngIf="job" class="card-body pb-1">
        <fieldset [disabled]="readonly">
          <abi-form-field [horizontal]="false" label="First name" [errors]="formErrors.firstName">
            <input type="text" formControlName="firstName">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
          <abi-form-field [horizontal]="false" label="Last name" [errors]="formErrors.lastName">
            <input type="text" formControlName="lastName">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
          <abi-form-field [horizontal]="false" label="Company name">
            <input type="text" formControlName="companyName">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
          <abi-form-field [horizontal]="false" label="Email" [errors]="formErrors.emailAddress">
            <input type="text" formControlName="emailAddress">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
          <abi-form-field [horizontal]="false" label="Mobile" [errors]="formErrors.mobile">
            <input type="text" [mask]="phoneMask" formControlName="mobile">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
          <abi-form-field [horizontal]="false" label="Address" [errors]="formErrors.line1">
            <input type="text" formControlName="line1">
            <!-- (change)="updateJob($event)"-->
          </abi-form-field>
        </fieldset>
      </div>

    </div>

    <div class="card mb-1">
      <div class="card-header py-0 pr-0 overflow-hidden">
        <h4 class="card-title mb-0 my-2 float-left">Contribution</h4>
        <a *ngIf="readonly" class="btn btn-primary float-right mt-1 mr-3" [routerLink]="[jobPath, 'fbcreate']">
          <i class="fas fa-pencil-alt"></i> New Donation
        </a>
      </div>
      <div *ngIf="job" class="card-body pb-1">
        <div class="invalid-feedback d-block">
          <!-- *ngIf="errors"-->
          <span *ngFor="let msg of formErrors['donationType']" class="d-block">{{ msg }}</span>
        </div>

        <fieldset [disabled]="readonly" formArrayName="lines">

          <div *ngFor="let line of job.lines; index as i; last as isLast" class="form-group" [formGroupName]="i">
            <div class="form-check mb-2">
              <input class="form-check-input" type="radio" [id]="line.lineId" name="donationType" [value]="i"
                (change)="choose(line, i)" [formControl]="donationType" [class.is-invalid]="donationType.invalid">
              <label class="form-check-label" [for]="line.lineId">{{ line.line2 }}</label>
            </div>
            <!--
        <button type="button" class="btn btn-outline-primary btn-sm" [class.active]="line.quantityOrdered" (click)="choose(line)">Select</button>
        {{ line.line1 }}-->

            <div class="form-row">
              <div class="col">
                <input *ngIf="line.typeId === 'STK'" abiTypeahead abiStock="STK" [preLoad]="true"
                  (selectItem)="selectDonation($event.item, line)" placeholder="Select Donation..." inputDisplay="name"
                  dropDownDisplay="name" formControlName="itemId" />
              </div>
              <div class="col">
                <input *ngIf="line.typeId === 'STK'" type="number" min="100.00" max="99999.00" formControlName="price"
                  class="text-right ml-2 mr-3" />
              </div>
            </div>
            <div *ngIf="!isLast" class="text-center">
              <br>
              or
              <hr class="mt-0">
            </div>
            <abi-form-field *ngIf="line.typeId !== 'STK'" labelColClass="col-sm-6" label="Posting date"
              [errors]="formErrors[i + '_field3']">
              <div class="input-group">
                <input ngbDatepicker name="dateOfPurchase" formControlName="field3" #dop="ngbDatepicker"
                  [minDate]="minreqDate" (dateSelect)="updatePrice($event, line, i)"
                  [markDisabled]="isBlocked.bind(this)" placeholder="Select Date..." />
                <!--input formControlName="field3" placeholder="Select Date..." /-->
                <div class="input-group-append">
                  <button type="button" class="btn btn-secondary" (click)="dop.toggle()"
                    [disabled]="lines.at(i).get('field3').disabled">
                    <i class="fas fa-calendar-alt fa-fw"></i>
                  </button>
                </div>
              </div>
            </abi-form-field>
            <abi-form-field *ngIf="line.typeId !== 'STK'" labelColClass="col-sm-6" label="Donation Amount">
              <input type="number" min="0.00" max="99999.00" formControlName="price" class="text-right" />
            </abi-form-field>
            <div *ngIf="!unpaid && line.quantityDelivered" class="form-row mt-3">
              <div class="col">
                <dl class="row">
                  <dt class="col-6">Receipt</dt>
                  <dd class="col-6"><a [routerLink]="['certificate', line.invoice]">
                      {{ line.invoice }} </a></dd>
                  <ng-template [ngIf]="line.field3">
                    <dt class="col-6">Ref No.</dt>
                    <dd class="col-6"> {{ line.field4 }} </dd>
                    <dt class="col-6">Posting Date</dt>
                    <dd class="col-6"> {{ line.field3|date }} </dd>
                  </ng-template>
                </dl>

              </div>

            </div>
          </div>
        </fieldset>

        <form *ngIf="canPay()" #mygateForm ngNoForm method="POST"
          action="https://virtual.mygateglobal.com/PaymentPage.cfm">
          <!--*ngIf="unpaid" -->
          <input type="hidden" name="MerchantID" value="6D687F6F-B463-45FA-92ED-779724A4282B">
          <input type="hidden" name="ApplicationID" [ngModel]="myGateApplicationId"
            [ngModelOptions]="{standalone: true}">
          <input type="hidden" name="Mode" [ngModel]="myGateMode" [ngModelOptions]="{standalone: true}">
          <input type="hidden" name="MerchantReference" [ngModel]="paymentReference()"
            [ngModelOptions]="{standalone: true}">
          <input type="hidden" name="Amount" [ngModel]="unpaidForm.toFixed(2)" [ngModelOptions]="{standalone: true}">
          <input type="hidden" name="txtDisplayCurrencyCode" value="ZAR">
          <input type="hidden" name="txtCurrencyCode" value="ZAR">

          <input type="hidden" name="RedirectSuccessfulURL" [ngModel]="postbackUrl() + 'success'"
            [ngModelOptions]="{standalone: true}">
          <input type="hidden" name="RedirectFailedURL" [ngModel]="postbackUrl() + 'fail'"
            [ngModelOptions]="{standalone: true}">
          <div class="table-responsive">
            <table class="table table-sm">
              <tfoot>
                <tr>
                  <td><b>
                      Total
                    </b>
                  </td>
                  <td class=text-right><b>{{ unpaidForm }}</b></td>
                  <!--|number:'1.2-2'-->
                </tr>
              </tfoot>
            </table>
          </div>
          <div *ngIf="!readonly " class="row">
            <div class="col">
              <button [disabled]="!canPay() || form.invalid" type="button" class="btn btn-primary float-right"
                (click)="makePayment(mygateForm)">
                <i class="fas fa-shopping-cart"></i> Pay
              </button>
              <!--button type="button" class="btn btn-primary float-right mr-2" (click)="cancelJob(cancelDialog)">
                <i class="fas fa-times"></i> Cancel
              </button-->
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-link float-right" (click)="showText(termsDialog, false)">Privacy
          Notice</button>
        <button type="button" class="btn btn-link float-right" (click)="showText(termsDialog, true)">Terms and
          Conditions</button>
      </div>
      <img src="assets/bcpf-logo.jpg" class="card-img-bottom" alt="BCPF" />

    </div>
  </div>
  <div class="card mt-3">
    <div class="card-header py-0 pr-0 overflow-hidden">
      <h4 class="card-title mb-0 my-2 float-left">Donation History</h4>
      <a *ngIf="readonly" class="btn btn-primary float-right mt-1 mr-3" [routerLink]="[jobPath, 'fbcreate']">
        <i class="fas fa-pencil-alt"></i>New Donation
      </a>
    </div>
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Date</th>
            <th>Nature</th>
            <th class="text-right">Amount</th>
            <th>Receipt</th>
            <th>Ref. No</th>
            <th>Posting Date</th>
          </tr>
        </thead>
        <tr *ngFor="let job of paidJobs">
          <td>{{ job.lines[0].field5 }}</td>
          <td>{{ job.lines[0].line1 }}</td>
          <td class="text-right">{{ job.lines[0].price }}</td>
          <td><a
              [routerLink]="[jobPath, job.jobId, generateJobCheckDigit(job.jobId), 'certificate', job.lines[0].invoice]">
              {{ job.lines[0].invoice }}</a></td>
          <td>{{ job.lines[0].field4 }}</td>
          <td>{{ job.lines[0].field3|date }}</td>
        </tr>
        <tbody>
        </tbody>
      </table>
    </div>
  </div>

  <div class="mt-5 text-center">
    <a target="_blank" href="http://www.credit-card-logos.com">
      <img alt="MasterCard and Visa Logo" src="https://developers.wirecard.co.za/images/logos/mc_vs.png" height="65"
        width="210" />
    </a>
    <a target="_blank" href="http://www.wirecard.co.za/">
      <img alt="Wirecard Logo" src="https://developers.wirecard.co.za/images/logos/Wirecard-Secure-Transaction-Logo.png"
        height="157" width="124" />
    </a>
  </div>

  <ng-template #termsDialog>
    <!--h5 mat-dialog-title>Terms and Conditions</h5-->
    <div mat-dialog-content [innerHTML]="theText|async">
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Ok</button>
    </div>
  </ng-template>

  <ng-template #cancelDialog>
    <h5 mat-dialog-title>Confirm</h5>
    <div mat-dialog-content>
      Are you sure you would like to cancel this quotation?
    </div>
    <div mat-dialog-actions>
      <button mat-button [mat-dialog-close]="false" translate="System.No"></button>
      <button mat-button [mat-dialog-close]="true" translate="System.Yes"></button>
    </div>
  </ng-template>
